module.exports = __webpack_public_path__ + "static/media/57.fad8aa09.jpg";